export var MessageType;
(function (MessageType) {
    // Auth
    MessageType["AUTH_REQUEST"] = "auth_request";
    MessageType["AUTH_RESPONSE"] = "auth_response";
    // Heartbeat
    MessageType["PING"] = "ping";
    MessageType["PONG"] = "pong";
    // Command execution
    MessageType["EXEC_COMMAND"] = "exec_command";
    MessageType["EXEC_RESULT"] = "exec_result";
    // File operations
    MessageType["READ_FILE"] = "read_file";
    MessageType["WRITE_FILE"] = "write_file";
    MessageType["FILE_RESULT"] = "file_result";
    // Status
    MessageType["STATUS_UPDATE"] = "status_update";
    MessageType["ERROR"] = "error";
    // Desktop bridge (状态桥)
    MessageType["BRIDGE_LIST_SESSIONS"] = "bridge_list_sessions";
    MessageType["BRIDGE_SESSION_LIST"] = "bridge_session_list";
    MessageType["BRIDGE_WATCH"] = "bridge_watch";
    MessageType["BRIDGE_UNWATCH"] = "bridge_unwatch";
    MessageType["BRIDGE_EVENT"] = "bridge_event";
    MessageType["BRIDGE_SEND"] = "bridge_send";
    MessageType["BRIDGE_SEND_RESULT"] = "bridge_send_result";
    // Persistent PTY (持久终端)
    MessageType["PTY_OPEN"] = "pty_open";
    MessageType["PTY_OPENED"] = "pty_opened";
    MessageType["PTY_INPUT"] = "pty_input";
    MessageType["PTY_OUTPUT"] = "pty_output";
    MessageType["PTY_RESIZE"] = "pty_resize";
    MessageType["PTY_CLOSE"] = "pty_close";
    MessageType["PTY_CLOSED"] = "pty_closed";
    // Task notification (任务完成提醒)
    MessageType["NOTIFY_EVENT"] = "notify_event";
    // Project overview (项目总览)
    MessageType["PROJECT_LIST"] = "project_list";
    MessageType["PROJECT_LIST_RESULT"] = "project_list_result";
    MessageType["PROJECT_FOCUS"] = "project_focus";
    MessageType["PROJECT_FOCUS_RESULT"] = "project_focus_result";
    // ---- 插件中心（五期·十一） ----
    MessageType["PLUGINS_LIST"] = "plugins_list";
    MessageType["PLUGINS_LIST_RESULT"] = "plugins_list_result";
    MessageType["PLUGINS_SELFTEST"] = "plugins_selftest";
    MessageType["PLUGINS_SELFTEST_RESULT"] = "plugins_selftest_result";
    MessageType["PLUGINS_SET_ENABLED"] = "plugins_set_enabled";
    // Task card (任务汇报卡片)
    MessageType["TASK_CARD"] = "task_card";
    // Director chat (对话式总管)
    MessageType["CHAT_SEND"] = "chat_send";
    MessageType["CHAT_EVENT"] = "chat_event";
    MessageType["CHAT_CONFIRM"] = "chat_confirm";
    // Attention queue (待查看闹铃) & liveness (活性心跳)
    MessageType["ATTENTION_RING"] = "attention_ring";
    MessageType["ATTENTION_ACK"] = "attention_ack";
    MessageType["ACTIVITY_TICK"] = "activity_tick";
    // ---- APP 内建远程调试（五期·十八）：同租户定向，绝不出租户 ----
    MessageType["APP_DEBUG_CMD"] = "app_debug_cmd";
    MessageType["APP_DEBUG_RESULT"] = "app_debug_result";
    // ---- 项目点选开/关（五期·十九）：点选是主通道，不过 LLM 零误识别；语音/打字说名字保留为辅助 ----
    MessageType["FOLDER_LIST_REQ"] = "folder_list_req";
    MessageType["FOLDER_LIST_RES"] = "folder_list_res";
    MessageType["OPEN_PROJECT"] = "open_project";
    MessageType["OPEN_PROJECT_RESULT"] = "open_project_result";
    MessageType["PROJECT_CLOSE"] = "project_close";
    MessageType["PROJECT_CLOSE_RESULT"] = "project_close_result";
})(MessageType || (MessageType = {}));
export function createMessage(type, payload, id) {
    return {
        id: id || generateId(),
        type,
        timestamp: Date.now(),
        payload,
    };
}
export function generateId() {
    return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
export function isValidMessage(msg) {
    if (!msg || typeof msg !== 'object')
        return false;
    const m = msg;
    return (typeof m.id === 'string' &&
        typeof m.type === 'string' &&
        typeof m.timestamp === 'number');
}
export { matchVoiceConfirm, voiceBroadcast } from './voice.js';
